import React, { FC, ReactElement } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import InfoBubble from '../../../ui/InfoBubble/InfoBubble';
import ClockIcon from '../../../ui/icons/Clock/Clock';
import useEddTimeRange from '../hooks/useEddTimeRange';

const EddTimeRange: FC = (): ReactElement | null => {
  const { bodytextDefaultNone: bodytextDefaultStyle } = useTheme();

  const formattedEddTimeRange = useEddTimeRange();

  if (!formattedEddTimeRange) return null;

  return (
    <div style={{ display: 'inline-block' }}>
      <InfoBubble icon={<ClockIcon />}>
        <div
          aria-label={`${formattedEddTimeRange[0]} - ${formattedEddTimeRange[1]}`}
          style={{ ...bodytextDefaultStyle, marginLeft: '0.5rem' }}
        >
          <span aria-hidden="true">{formattedEddTimeRange[0]}</span>
          <span> - </span>
          <span aria-hidden="true">{formattedEddTimeRange[1]}</span>
        </div>
      </InfoBubble>
    </div>
  );
};

export default EddTimeRange;
